import { ContentfulImage } from '@ecomm/contentful-components'
import { includeImage } from '../../../lib/utils'
import type { HeaderRedesignSchema } from '../schema'

export function CallSpecialistImage({
  images
}: Pick<HeaderRedesignSchema, 'images'>) {
  const menuImage = includeImage({ imageId: '6UMbGUo2vMm65W8HkHT2ni' }, images)

  return menuImage.image ? (
    <ContentfulImage
      classNameOverride="bg-transparent"
      {...menuImage.image}
      height={50}
      quality={90}
      width={50}
    />
  ) : null
}
